<template>
  <nv-tab-page>
    <template slot="toolbar">
      <v-btn color="secondary" class="mb-5" @click="addAttribute">
        <v-icon left>mdi-plus</v-icon>
        Add attributes
      </v-btn>
    </template>
    <v-row>
      <v-col v-for="(attr, index) in selectedAttributes" :key="index" cols="12">
        <v-card outlined>
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="4">
                <v-select
                  v-model="attr.key"
                  :items="getAvailableKeysForRow(index)"
                  label="Attribute"
                  @change="onKeyChange(index)"
                />
              </v-col>
              <v-col cols="12" sm="7">
                <v-select
                  v-if="attr.key"
                  v-model="attr.value"
                  :items="getValueOptions(attr.key)"
                  :item-text="getValueItemText(attr.key)"
                  :item-value="getValueItemValue(attr.key)"
                  label="Value"
                />
                <v-alert
                  v-if="
                    attr.key === 'status' &&
                      (attr.value === 'inactive' || attr.value === 'archived')
                  "
                  type="warning"
                  dense
                  outlined
                  class="mt-2"
                >
                  Note: All the products of the applications will be suspended before marking the
                  application inactive or archived.
                </v-alert>
              </v-col>
              <v-col cols="12" sm="1">
                <v-btn icon color="error" @click="removeAttribute(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </nv-tab-page>
</template>

<script>
const attributeDefinitions = {
  status: {
    label: 'Status',
    items: [
      { text: 'Active', value: 'active' },
      { text: 'Inactive', value: 'inactive' },
      { text: 'Archived', value: 'archived' },
    ],
  },
};

export default {
  name: 'AttributesBulkUpdate',
  props: {
    isEditable: { type: Boolean, default: true },
  },
  data: () => ({
    selectedAttributes: [],
  }),
  methods: {
    getAvailableKeysForRow(rowIndex) {
      const selectedKeys = this.selectedAttributes
        .map((a, idx) => (idx !== rowIndex ? a.key : null))
        .filter(k => k !== null);

      return Object.keys(attributeDefinitions)
        .filter(key => !selectedKeys.includes(key))
        .map(key => ({
          text: attributeDefinitions[key].label,
          value: key,
        }));
    },
    getValueOptions(key) {
      if (!key || !attributeDefinitions[key]) return [];
      const def = attributeDefinitions[key];
      return def.items || [];
    },
    getValueItemText() {
      return 'text';
    },
    getValueItemValue() {
      return 'value';
    },
    addAttribute() {
      this.selectedAttributes.unshift({ key: null, value: null });
    },
    removeAttribute(index) {
      this.selectedAttributes.splice(index, 1);
    },
    onKeyChange(index) {
      this.selectedAttributes[index].value = null;
    },
    getData() {
      const data = {};
      this.selectedAttributes.forEach(attr => {
        if (attr.key && attr.value !== null && attr.value !== '') {
          data[attr.key] = attr.value;
        }
      });
      return data;
    },
  },
};
</script>
